import { components } from 'react-select'

/* eslint-disable react/prop-types */
export const labelledSelectComponents = (Label) => {
  const Option = ({ data, ...props }) => <components.Option {...props}><Label data={data} /></components.Option>
  const SingleValue = ({ data, ...props }) => <components.SingleValue {...props}><Label data={data} /></components.SingleValue>

  return { Option, SingleValue }
}
/* eslint-enable react/prop-types */
